module.exports = __webpack_public_path__ + "media/bootstrap-icons/bell-slash-fill-afeddd85.svg";